__turbopack_context__.v({
  "active": "styles-module__oX35tq__active",
  "dropper": "styles-module__oX35tq__dropper",
  "dropperContent": "styles-module__oX35tq__dropperContent",
  "dropperHeader": "styles-module__oX35tq__dropperHeader",
  "dropperIcon": "styles-module__oX35tq__dropperIcon",
  "dropperTitle": "styles-module__oX35tq__dropperTitle",
  "rotatedDown": "styles-module__oX35tq__rotatedDown",
  "rotatedUp": "styles-module__oX35tq__rotatedUp",
});
